import {Component, Input} from '@angular/core';
import {Character} from 'gamesis-story-client';
import {Destroyable} from './destroyable';
import {takeUntil} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {selectCharacterById} from 'gamesis-state';

@Component({
    selector: 'character-chip',
    template: `
        @if (_character) {
            <ion-chip [outline]="outline" [color]="color" class="ion-no-margin">
                <ion-avatar [characterAvatar]="_character"></ion-avatar>
                <ion-text>{{ _character.name }}</ion-text>
            </ion-chip>
        }
    `,
    styles: [`
        :host {
            display: inline-block;
        }

        ion-chip {
            padding-top: 1px;
            padding-bottom: 0;
            padding-inline-start: 7px;
            min-height: 36px;
            border-radius: 18px;
            border: 1px solid var(--ion-color-dark);
        }

        ion-chip ion-avatar {
            margin-right: 4px;
            border-color: transparent !important;
        }
    `],
    standalone: false
})
export class CharacterChipComponent extends Destroyable {
    public _character: Character;

    @Input()
    public outline = false;

    @Input()
    public color: string;

    @Input()
    public set character(character: string | Character) {
        this.ngUnsubscribe.next(null);
        if (typeof character === 'string') {
            this.store.select(selectCharacterById(character as string))
                .pipe(
                    takeUntil(this.ngUnsubscribe)
                )
                .subscribe((char) => {
                    this._character = char;
                });
        } else {
            this._character = character as Character;
        }
    }

    constructor(private store: Store) {
        super();
    }
}
